import AssignBodyItem from './AssignBodyItem';

import { DebitCardOptions } from 'types';

import { createStyles, makeStyles } from '@mui/styles';

const useStyles = makeStyles(() =>
    createStyles({
        body: {
            position: 'relative',
            background: '#FBFBFF',
            borderRadius: '0 0 16px 16px',
            boxSizing: 'border-box',
            padding: '24px 24px 0 24px',
            width: '100%'
        },
        bodyItems: {
            position: 'relative',
            top: '-56px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
        },
        content: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#EBEBFF',
            borderRadius: '16px',
            color: '#1F2152',
            paddingTop: '64px'
        },
        photoContainer: {
            position: 'absolute',
            left: 'calc(50% - 50px)',
            top: '-48px',
            borderRadius: '50%',
            height: '100px',
            width: '100px',
            '& img': {
                borderRadius: '50%',
                height: '100%',
                objectFit: 'cover',
                width: '100%'
            }
        },
        subtitle: {
            fontSize: '1rem',
            fontWeight: 300,
            padding: '0 8px 48px 8px',
            textAlign: 'center',
            '& b': {
                fontWeight: 900
            }
        }
    })
);

type AssignBodyProps = {
    debitCardOptions: DebitCardOptions[];
    photo: string;
    setAssignPopUp?: (assignView: boolean) => void;
    setDebitType: (
        type: 'givecard' | 'pex' | 'virtual-givecard' | null
    ) => void;
    setReplaceView?: (replaceView: boolean) => void;
    setShowVirtualCardPopup?: (showVirtualCardPopup: boolean) => void;
};

const AssignBody: React.FC<AssignBodyProps> = ({
    debitCardOptions,
    photo,
    setAssignPopUp,
    setDebitType,
    setReplaceView,
    setShowVirtualCardPopup
}) => {
    const classes = useStyles();

    return (
        <div className="default-body-container">
            <div className={classes.photoContainer}>
                <img src={photo} alt="profile" />
            </div>
            <div className={classes.content}>
                <h4 style={{ margin: '1rem 0 0.5rem 0' }}>
                    Assigning Debit Card
                </h4>
                <span className={classes.subtitle}>
                   Would you like to give this member a physical card or a virtual card?
                </span>
                <div className={classes.body}>
                    <div className={classes.bodyItems}>
                        {debitCardOptions.map((cardOption) => (
                            <AssignBodyItem
                                key={cardOption.type}
                                cardOption={cardOption}
                                setAssignPopUp={setAssignPopUp}
                                setDebitType={setDebitType}
                                setReplaceView={setReplaceView}
                                setShowVirtualCardPopup={setShowVirtualCardPopup}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AssignBody;
